import React from 'react';
import Product from '../../../models/Product';
import Pagination from '../../../models/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, Paper, Typography, TableContainer, Stack } from '@mui/material';
import PaginationButtons from '../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow, ISTableCell } from '../../Utils/ISTable';
import { useTranslation } from 'react-i18next';
import { Row } from '../Preorders/PreorderProducts'
import { formattedCurrency } from '../../../utils/StringUtils';

interface Props {
  rows: Row[];
  loading: boolean;
  pagination?: Pagination;
  fromIn?: boolean;
  priceList: number;
  onClickInfo?: (product: Product) => void;
  onChangePage?: (page: number) => void;
}

const PriceList: React.FC<Props> = (props) => {
  const { t } = useTranslation(['product', 'others', 'preorder'])

  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }

  const tooltipText = (text: string) =>
    <Paper elevation={2} sx={{ padding: "10px" }}>
      <Typography >{text}</Typography>
    </Paper>

  return (

    <Stack style={{ display: 'flex', flexDirection: 'column', height: 'calc(92% - var(--header-height)', borderRadius: "10px", margin: "10px" }}>
      <ISTableTitle title={`${t('priceList', { ns: 'others'})}${props.priceList ? ` - ${props.priceList}` : ''}`} />
      <TableContainer sx={{ overflowX: 'auto', height: '100%' }}>
        <Table stickyHeader size="medium" >
          <TableHead>
            <TableRow selected={true}>
              <ISTableHeaderCell>{t('code')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('description')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('section')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('brand')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('group')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('subgroup')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('measurement')}</ISTableHeaderCell>
              <ISTableHeaderCell align="right">{t('package')}</ISTableHeaderCell>
              <ISTableHeaderCell align="right">{t('listPrice', { ns: 'others' })}</ISTableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!props.loading && props.rows.map((row, rowIndex) =>
              row.data.products.sort((a, b) => (a?.order || 0) - (b?.order || 0)).map((product, index) =>
                <ISTableRow key={rowIndex + index} color={mapActionToColor(row.action)}>
                  <ISTableCell tooltip={tooltipText(`${row.data.description}${product.information ? `- ${product.information}` : ``}`)}>
                    {product.code}</ISTableCell>
                  <ISTableCell tooltip={tooltipText(`${row.data.description}${product.information ? `- ${product.information}` : ``}`)}>
                    {product.description}</ISTableCell>
                  <TableCell>{product.sectionName}</TableCell>
                  <TableCell>{product.brandName}</TableCell>
                  <TableCell>{product.groupName}</TableCell>
                  <TableCell>{product.subgroupName}</TableCell>
                  <TableCell>{product.measurementName}</TableCell>
                  <TableCell align="right">{product.package}</TableCell>
                  <TableCell align='right'>{formattedCurrency(product.price)}</TableCell>
                </ISTableRow>
              ))}
          </TableBody>
        </Table>
        {props.loading &&
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress size={25} />
          </div>
        }
        <PaginationButtons pagination={props.pagination} />
      </TableContainer>
    </Stack>
  );
}

export default PriceList

